/**
 * The languages the web app offers. `intl` is the BCP 47 locale used for dates and numbers; digits stay
 * Latin in every language (`-u-nu-latn`), so amounts, dates and exports read the same whichever language
 * an employee picks.
 */
export const LANGUAGES = [
    { code: 'en', label: 'English', intl: 'en-GB' },
    { code: 'bn', label: 'বাংলা', intl: 'bn-BD' },
] as const;

export type LanguageCode = typeof LANGUAGES[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const isSupportedLanguage = (code: string | null | undefined): code is LanguageCode =>
    !!code && LANGUAGES.some(l => l.code === code);

/** The Intl locale for a language, with Latin digits. */
export const intlLocale = (code: string): string =>
    `${(LANGUAGES.find(l => l.code === code) ?? LANGUAGES[0]).intl}-u-nu-latn`;
